import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function createAlert(payload) {
    const r = await axios.post(`${API}/alerts`, payload);
    return r.data;
}

export async function listAlerts() {
    const r = await axios.get(`${API}/alerts`);
    return r.data.alerts || [];
}

export async function deleteAlert(alertId) {
    return axios.delete(`${API}/alerts/${alertId}`);
}

export async function verifyAlert(token) {
    const r = await axios.get(`${API}/alerts/verify`, { params: { token } });
    return r.data;
}

export async function unsubscribeAlert(token) {
    const r = await axios.get(`${API}/alerts/unsubscribe`, { params: { token } });
    return r.data;
}
